import { Instance, SnapshotOut, types } from "mobx-state-tree"

import { TypingStoreModel } from "./TypingStore"

/**
 * A RootStore model.
 */
export const RootStoreModel = types.model("RootStore").props({
  typingStore: types.optional(TypingStoreModel, {}),
})

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}
/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
